import { useEffect, useRef, useSyncExternalStore } from 'react'
import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'

const mobileQuery = window.matchMedia('(max-width: 767px)')
const subscribe = listener => {
  mobileQuery.addEventListener('change', listener)
  return () => mobileQuery.removeEventListener('change', listener)
}
export const useMobile = () => useSyncExternalStore(subscribe, () => mobileQuery.matches)

const backActions = new Set()
export function useBackAction(enabled, action, priority = 0) {
  const latest = useRef(action)
  latest.current = action
  useEffect(() => {
    if (!enabled) return
    const entry = { priority, run: () => latest.current() }
    backActions.add(entry)
    return () => backActions.delete(entry)
  }, [enabled, priority])
}

function goBack() {
  // Existing dialogs own their cancellation and confirmation semantics.
  const dialogs = [...document.querySelectorAll('.modal-bg')]
  if (dialogs.length) {
    const top = dialogs.sort((a, b) => Number(getComputedStyle(b).zIndex) - Number(getComputedStyle(a).zIndex))[0]
    top.click()
    return true
  }
  const action = [...backActions].sort((a, b) => b.priority - a.priority)[0]
  if (!action) return false
  action.run()
  return true
}

export function installMobileShell() {
  const viewport = window.visualViewport
  const resize = () => {
    document.documentElement.style.setProperty('--app-height', `${viewport?.height || window.innerHeight}px`)
  }
  resize()
  viewport?.addEventListener('resize', resize)
  window.addEventListener('resize', resize)
  window.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !event.defaultPrevented && mobileQuery.matches && goBack()) event.preventDefault()
  })
  if (!Capacitor.isNativePlatform()) return
  document.documentElement.classList.add('native-app')
  App.addListener('backButton', () => {
    if (goBack()) return
    if (location.hash && !['#/workbench', '#/login', '#/'].includes(location.hash)) {
      location.hash = '#/workbench'
      return
    }
    App.minimizeApp()
  })
}
